<template>
    <span v-if="urgencyLabel" class="tw-label" v-bind:class="urgencyLabel.style">
        {{ urgencyLabel.label }}
    </span>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import TicketWidgetComponent from '../../TicketWidgetComponent';
    import Event from '../../../models/Event';

    @Component({})

    export default class UrgencyLabel extends TicketWidgetComponent {
        @Prop() public remaining!: string;
        @Prop() public total!: number;

        urgencyLabel: any = false;

        // urgency label settings
        urgencyLabels: any = [
            {
                max: 20,
                label: '[quantity] tickets remaining'
            },
            {
                max: 10,
                label: 'Only [quantity] tickets remaining',
                style: 'warning'
            },
            {
                max: 1,
                label: 'Last ticket remaining',
                style: 'warning'
            }
        ]

        mounted() {
            this.setUp();
        }

        setUp() {
            this.urgencyLabel = this.getUrgencyLabel();
        }
        
        /**
        * @desc Gets the urgency label based on how many tickets are remaining
        * @return {Object}
        */
        getUrgencyLabel() : {} {
            let urgencyLabel: any = false;

            if(this.selectedEvent.showUrgencyLabels()) {
                // if an array
                if(this.selectedEvent.urgency_labels && this.selectedEvent.urgency_labels.length > 0) {
                    this.urgencyLabels[0].max = Math.ceil((this.total / 100) * this.selectedEvent.urgency_labels.first);
                    this.urgencyLabels[1].max = Math.ceil((this.total / 100) * this.selectedEvent.urgency_labels.second);
                }
                // if an object
                else if (this.selectedEvent.urgency_labels && !Array.isArray(this.selectedEvent.urgency_labels)) {
                    this.urgencyLabels[0].max = this.selectedEvent.urgency_labels.first ? Math.ceil((this.total / 100) * this.selectedEvent.urgency_labels.first) : 20;
                    this.urgencyLabels[1].max = this.selectedEvent.urgency_labels.second ? Math.ceil((this.total / 100) * this.selectedEvent.urgency_labels.second) : 10;
                }

                this.urgencyLabels.forEach((label:any) => {
                    if(this.remaining <= label.max) {
                        urgencyLabel = label;
                    }
                });
            }

            // if a label was found update the label to show the correct number of tickets
            if(urgencyLabel) {
                urgencyLabel.label = urgencyLabel.label.replace('[quantity]', this.remaining);

                if(urgencyLabel.style) {
                    urgencyLabel.style = 'tw-label--' + urgencyLabel.style;
                }
            }

            return urgencyLabel;
        }
    }
</script>